import script from "./CharaHome.vue?vue&type=script&setup=true&lang=js"
export * from "./CharaHome.vue?vue&type=script&setup=true&lang=js"

import "./CharaHome.vue?vue&type=style&index=0&id=1a0055b0&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0055b0"]])

export default __exports__